<template>
    <zen-one
        :showuserinfo="false"
        title="Penguatkuasaan: Notis 8A"
        :crumbs="crumbs"
    >
        <w-flex :gap="3" column>
            <w-card class="sh2">
                <PengeluaranNotis
                    :loading="loading"
                    :searchParams="searchParams"
                    :julat="julat"
                    :search="semak"
                    :daerahOptions="daerahOptions"
                    :mukimOptions="mukimOptions"
                    :julatOptions="julatOptions"
                    :yearOptions="yearOptions"
                    :jenisHakMilikOptions="jenisHakMilikOptions"
                ></PengeluaranNotis>
            </w-card>
            <z-page
                :append-button="true"
                icon="fal fa-paper-plane"
                :title="'Senarai Hak Milik Yang Terlibat Notis 8A'"
            >
                <w-flex column>
                    <div class="align-self-end w-flex align-center">
                        <w-alert
                            v-if="selection.length > 0"
                            info
                            :xs="true"
                            class="ma0"
                        >
                            {{ selection.length }} hakmilik telah dipilih.
                        </w-alert>

                        <w-button @click="pilihSemua('', true)" class="ml3">
                            Reset pilihan
                        </w-button>
                        <w-button @click="pilihSemua('')" class="ml3">
                            Pilih
                            {{
                                tItems2.hak_milik ? tItems2.hak_milik.length : 0
                            }}
                            hakmilik
                        </w-button>
                    </div>
                </w-flex>
                <Table
                    :headers="tHeader"
                    :items="tItems2.hak_milik ?? []"
                    :loading="loading"
                >
                    <template #item-cell.index="{ item, label, header, index }">
                        {{
                            (pagination.currentPage - 1) * pagination.perPage +
                            index
                        }}
                    </template>
                    <template #item-cell.notis="{ item, label, header, index }">
                        {{ `${item.notis} (${item.bilangan})` }}
                    </template>
                    <template
                        #item-cell.butiran="{ item, label, header, index }"
                    >
                        <w-button
                            @click="
                                dialogs.showButiranNotis = true;
                                notisToSee = item;
                            "
                            text
                        >
                            <w-icon> fal fa-list </w-icon>
                        </w-button>
                    </template>
                    <template #item-cell.check="{ item, label, header, index }">
                        <input
                            type="checkbox"
                            :value="{ id: item.id, notis_id: item.notis_id }"
                            v-model="selection"
                        />
                    </template>
                </Table>
                <TablePagination
                    :lastPage="getLastPage"
                    :currentPage="tItems2.pagination.currentPage"
                    :perPage="tItems2.pagination.perPage"
                    @onClick="onPaginationChange($event, '')"
                />
                <Toolbar
                    :items="tItems2"
                    :printUrl="`${this.apiBaseUrl}/cukai/pdfNotis8A`"
                    :urlWarta="`${this.apiBaseUrl}/cukai/suratWarta`"
                    :printExcel="`${apiBaseUrl}/cukai/excelNotis`"
                    :checkSelect="selection"
                    :searchParams="searchParams"
                />
            </z-page>
        </w-flex>
        <ButiranNotisDialog
            :title="`Butiran Notis ${notisToSee.notis} ${notisToSee.no_hm}`"
            :notis="notisToSee"
            :show="dialogs.showButiranNotis"
            @close="dialogs.showButiranNotis = false"
        ></ButiranNotisDialog>
    </zen-one>
</template>
<script>
import { ref, defineComponent, onMounted, watch, computed } from "vue";
import WaveUI from "wave-ui";
import _ from "lodash";
import PengeluaranNotis from "./PengeluaranNotis";
import Table from "../../Component/Table";
import TablePagination from "../../Component/TablePagination";
import Toolbar from "./Toolbar";
import ButiranNotisDialog from "./ButiranNotisDialog";
import { usePage } from '@inertiajs/inertia-vue3';
export default defineComponent({
    components: {
        PengeluaranNotis,
        Table,
        TablePagination,
        Toolbar,
        ButiranNotisDialog,
    },
    setup() {
        const waveui = new WaveUI(app, {});

        const loading = ref(false);
        const pagination = ref({
            perPage: 10,
            currentPage: 1,
            lastPage: 1,
        });
        const total = ref(0);

        const apiBaseUrl = process.env.MIX_API_BASE_URL;
        const selection = ref([]);
        const tHeader = ref([
            { label: "#", key: "index" },
            { label: "No. Hak Milik", key: "no_hm" },
            { label: "Nama", key: "nama" },
            { label: "Tunggakan Dari", key: "tunggakan_dari" },
            { label: "Tunggakan Hingga", key: "tunggakan_hingga" },
            { label: "Cukai Tanah/Petak (RM)", key: "cukai", align: "right" },
            {
                label: "Tunggakan Cukai Tanah/Petak (RM)",
                key: "tunggakan",
                align: "right",
            },
            { label: "Notis (Bilangan)", key: "notis" },
            { label: "Butiran", key: "butiran" },
            { label: "", key: "check" },
        ]);

        const tItems2 = ref({ pagination });

        function pilihSemua(e, reset) {
            if (reset) {
                selection.value = [];
                return;
            }
            const temp = selection.value.concat(
                tItems2.value.hak_milik.map((e) => {
                    return { id: e.id, notis_id: e.notis_id };
                })
            );
            selection.value = _.uniqBy(temp, "id");
        }

        const julatOptions = ref([
            { value: ">=", label: ">=" },
            { value: ">", label: ">" },
            { value: "=", label: "=" },
            { value: "<=", label: "<=" },
            { value: "<", label: "<" },
        ]);

        const yearOptions = ref([
            { value: "2014", label: "2014" },
            { value: "2015", label: "2015" },
            { value: "2016", label: "2016" },
            { value: "2017", label: "2017" },
            { value: "2018", label: "2018" },
            { value: "2019", label: "2019" },
            { value: "2020", label: "2020" },
            { value: "2021", label: "2021" },
            { value: "2022", label: "2022" },
        ]);

        const mukimOptions = ref([]);
        const daerahOptions = ref([]);
        const jenisHakMilikOptions = ref([]);

        const crumbs = ref([
            { label: "iHasil", route: "/" },
            { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
            { label: "8A", route: "/cukai-tanah/notis-8a" },
        ]);

        const julat = ref({
            jenis: null,
            amaun: null,
        });
        watch(julat.value, (ov, nv) => {
            searchParams.value.julat_tunggakan = nv.jenis + nv.amaun;
        });

        const searchParams = ref({
            kod_daerah: null,
            kod_mukim: "01",
            julat_tunggakan: null,
            tunggakan_dari: null,
            tunggakan_hingga: null,
            jenis_hm: null,
            nama: null,
            no_hm: null,
            notis: "8A",
        });
        const jabatan = usePage().props.value.auth.user.jabatan_id;
        const dialogs = ref({
            showButiranNotis: false,
        });
        const notisToSee = ref({});

        const getLastPage = computed(() => {
            return tItems2.value.total && tItems2.value.total > 0
                ? Math.ceil(
                      tItems2.value.total / tItems2.value.pagination.perPage
                  )
                : 1;
        });

        function onPaginationChange(e) {
            tItems2.value.pagination.currentPage = e.value.currentPage;
            tItems2.value.pagination.perPage = e.value.perPage;
            search();
        }
        async function semak() {
            loading.value = true;
            selection.value = [];
            await search()
                .then((e) => {
                    waveui.notify({
                        success: true,
                        message: `Semakan selesai.`,
                        timeout: 3000,
                    });
                })
                .catch((e) => {
                    console.log(e);
                    waveui.notify({
                        error: true,
                        message: `Ralat`,
                        timeout: 3000,
                    });
                })
                .finally(() => {
                    loading.value = false;
                });
        }

        async function search() {
            const offset =
                (pagination.value.currentPage - 1) * pagination.value.perPage;
            const limit = pagination.value.perPage;

            tItems2.value.pagination.currentPage = 1;
            tItems2.value.pagination.lastPage = 1;
            tItems2.value.pagination.perPage = 10;
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: `${apiBaseUrl}/cukai/penguatkuasaan`,
                    responseType: "json",
                    params: { ...searchParams.value, offset, limit },
                })
                    .then((e) => {
                        tItems2.value = { ...e.data, pagination };
                        resolve(e);
                    })
                    .catch((e) => {
                        reject(e);
                    });
            });
        }

        onMounted(() => {
            async function fetchMukim() {
                await axios({
                    method: "get",
                    url: `${apiBaseUrl}/daerah`,
                    responseType: "json",
                }).then((e) => {
                    searchParams.value.kod_daerah = e.data[0].kod;
                    daerahOptions.value = e.data.map((el) => {
                        return {
                            value: el.kod,
                            label: `${el.kod} - ${el.keterangan}`,
                        };
                    });
                });

                await axios({
                    method: "get",
                    url: `${apiBaseUrl}/jabatanToDaerah?jabatan=${jabatan}`,
                    responseType:'json',
                }).then((e)=>{
                    console.log(e);
                    searchParams.value.kod_daerah=e.data[0].kod_daerah;
                });


                await axios({
                    method: "get",
                    url: `${apiBaseUrl}/daerah/${searchParams.value.kod_daerah}/mukim`,
                    responseType: "json",
                }).then((e) => {
                    mukimOptions.value = e.data.map((el) => {
                        return {
                            value: el.kod,
                            label: `${el.kod} - ${el.keterangan}`,
                        };
                    });
                });
            }

            async function fetchJenisHakMilik() {
                await axios({
                    method: "get",
                    url: `${apiBaseUrl}/jenis-hak-milik`,
                    responseType: "json",
                }).then((e) => {
                    jenisHakMilikOptions.value = e.data.map((el) => {
                        return {
                            value: el.kod,
                            label: `${el.kod} - ${el.keterangan}`,
                        };
                    });
                });
            }
            fetchMukim();
            fetchJenisHakMilik();
        });

        return {
            apiBaseUrl,
            loading,
            total,
            pagination,
            onPaginationChange,
            getLastPage,
            crumbs,
            tHeader,
            tItems2,
            jabatan,
            yearOptions,
            julatOptions,
            daerahOptions,
            mukimOptions,
            jenisHakMilikOptions,
            searchParams,
            julat,
            search,
            semak,
            selection,
            dialogs,
            notisToSee,
            pilihSemua,
        };
    },
});
</script>
